
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account-opening-process",
      function () {
        return require("private-next-pages/account-opening-process/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account-opening-process"])
      });
    }
  